import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito experiencia en jardinería?',
    answer: 'No. Esta guía está diseñada exactamente para ti. Empieza desde cero, sin jerga técnica ni conocimientos previos. Todo está explicado paso a paso, con fotos y ejemplos claros.'
  }, {
    question: 'Ya vi videos en YouTube sobre esto, ¿qué tiene de diferente?',
    answer: 'Los videos muestran pasos sueltos. Esta guía te enseña el sistema completo — incluyendo por qué cada paso funciona y cómo evitar los errores que los videos no mencionan.'
  }, {
    question: '¿Funciona con cualquier planta?',
    answer: 'Incluye una guía por especie para que sepas exactamente qué técnica usar con cada tipo de planta. Desde las más fáciles hasta las más desafiantes.'
  }, {
    question: '¿Y si quiero vender? ¿Es suficiente esta guía?',
    answer: 'Sí. El Combo 3 incluye el módulo de escalado comercial que cubre cómo organizar tu producción para vender con consistencia.'
  }, {
    question: '¿Funciona para mi zona o clima?',
    answer: 'Sí. La guía incluye consejos adaptados para climas de Latinoamérica. No son consejos genéricos de Europa o Estados Unidos.'
  }, {
    question: '¿Es seguro comprar por internet?',
    answer: 'Sí. Tu compra está procesada por Hotmart, la plataforma #1 de productos digitales en Latinoamérica. Usan encriptación bancaria y protegen tus datos.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Apenas completas el pago, recibes un email con acceso inmediato a todos los PDFs. No tienes que esperar envíos ni descargar apps. Lo abres desde tu celular o computador.'
  }, {
    question: '¿Y si no me funciona?',
    answer: 'Tienes garantía de satisfacción de 7 días. Si aplicas el sistema y no estás conforme, te devolvemos el dinero. Sin preguntas, sin vueltas.'
  }];
  return <section className="py-20 bg-white" data-id="element-90">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="max-w-3xl mx-auto" data-id="element-92">
          <div className="text-center mb-12" data-id="element-93">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-[#4a7c2c]/10 rounded-full mb-4 text-[#4a7c2c]" data-id="element-94">
              <HelpCircle className="w-6 h-6" data-id="element-95" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-96">
              ¿Todavía tienes dudas? Es normal.
            </h2>
            <p className="text-xl text-gray-600" data-id="element-97">
              Estas son las preguntas más comunes antes de comprar:
            </p>
          </div>

          <div className="space-y-4" data-id="element-98">
            {faqs.map((faq, i) => <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-200 ${openIndex === i ? 'border-[#4a7c2c] shadow-md bg-[#fafaf9]' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-99">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-100">
                  <span className={`font-semibold ${openIndex === i ? 'text-[#4a7c2c]' : 'text-gray-900'}`} data-id="element-101">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${openIndex === i ? 'transform rotate-180 text-[#4a7c2c]' : ''}`} data-id="element-102" />
                </button>

                <AnimatePresence data-id="element-103">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-104">
                      <div className="px-5 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-105">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}